<div class="card card-body mb-0">

    <div class="row border-bottom pb-3 mb-3">
        <div class="col-12">

            <div class="pagination-space">
                 <div class="common-fiwe">
                    <div class="recent-table table-responsive custom-scrollbar invoice-table" id="table" style="max-height: 300px;">
                        <table class="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>
                                            {{"PROPERTIES.Broj računa" | translate}} - {{invoices?.length}}
                                    </th>

                                    <th>
                                            {{"PROPERTIES.Vrsta" | translate}}
                                    </th>

                                    <th>
                                            {{"PROPERTIES.Tip" | translate}}
                                    </th>

                                    <th>
                                            {{"PROPERTIES.Datum" | translate}}
                                    </th>

                                    <th>
                                            {{"PROPERTIES.Iznos" | translate}}
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let item of invoices; index as i">
                                    <td role="button">
                                        <p class="c-o-light">{{ item?.brojRacuna }}</p>
                                    </td>
                                    <td role="button">
                                        <p class="c-o-light">{{ item?.vrsta }}</p>
                                    </td>
                                    <td role="button">
                                        <p class="c-o-light">{{ item?.tip }}</p>
                                    </td>
                                    <td role="button">
                                        <p class="c-o-light">{{ item?.datum | date : "dd.MM.yyyy HH:mm" }}</p>
                                    </td>
                                    <td role="button">
                                        <p class="c-o-light">{{ item?.iznos | number : '1.2-2' }}</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
            <table class="table table-bordered table-striped">
                <tr class="bg-primary text-light">
                    <td class="text-end text-light">Fiskalni: {{ getFiskalniPromet() | number : '1.2-2'}}
                    </td>
                    <td></td>
                    <td class="text-end text-light">Reklamirani: {{ getReklamiraniPromet() | number :
                        '1.2-2'}} </td>
                    <td></td>
                    <td class="text-end text-light">Total: {{ getTotalPromet() | number : '1.2-2'}}</td>
                </tr>
            </table>
        </div>
    </div>

    <form [formGroup]="invoiceSearchForm">
        <div class="row col-12">
            <div class="col-lg-5 col-sm-12 form-group">
                <label class="fw-bold"> {{ "PROPERTIES.Od" | translate }} </label>
                <div class="form-group">
                    <div>
                        <input formControlName="fromDate" class="form-control digits" type="datetime-local"
                            (change)="dateChanged()" />
                    </div>
                    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
                                validation: 'required',
                                message: 'VALIDATORS.PoljeNeSmijeBitiPrazno',
                                control: invoiceSearchForm.controls.fromDate}">
                    </ng-container>
                </div>
            </div>

            <div class="col-lg-5 col-sm-12 form-group">
                <label class="fw-bold"> {{ "PROPERTIES.Do" | translate }} </label>
                <div class="form-group">
                    <div>
                        <input formControlName="toDate" class="form-control digits" type="datetime-local"
                            (change)="dateChanged()" />
                    </div>
                    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
                                validation: 'required',
                                message: 'VALIDATORS.PoljeNeSmijeBitiPrazno',
                                control: invoiceSearchForm.controls.toDate}">
                    </ng-container>
                </div>
            </div>

            <div class="col-lg-2 col-sm-12 form-group form-grrr">
                <button (click)="searchInvoices()" class="btn btn-primary mt-3 mb-3">
                    {{ "PROPERTIES.Pretraga" | translate }}
                    <span class="spinner-border spinner-border-sm text-light ms-1" role="status"
                        *ngIf="loading['invoices']">
                        <span class="sr-only">Loading...</span>
                    </span>
                </button>
            </div>

        </div>
    </form>

    <div class="row">
        <span placement="top">
            <div class="card-body">
                <button (click)="provjeriStatus()"
                    class="btn btn-primary d-flex align-items-center justify-content-center">
                    {{ "PROPERTIES.Provjeri dostupnost" | translate }}
                    <span class="spinner-border spinner-border-sm text-light ms-1" role="status"
                        *ngIf="loading['attention']">
                        <span class="sr-only">Loading...</span>
                    </span>
                </button>
            </div>

        </span>
    </div>


</div>

<ng-template #formError let-control="control" let-message="message" let-validation="validation">
    <ng-container *ngIf="control.hasError(validation) && control.touched">
        <small class="text-danger">{{ message | translate}}</small>
    </ng-container>
</ng-template>